import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertMeters',
    standalone: true,
    pure: true
})
export class ConvertMetersPipe implements PipeTransform {
    transform(meters: number | null | undefined): string {
        if (!meters) {
            return '0m';
        }
        if (meters >= 1000) {
            return (meters / 1000).toFixed(1) + 'km';
        } else {
            return meters.toFixed(0) + 'm';
        }
    }
}
